import { shallowRef } from 'vue';

const cityStateOptions = shallowRef([]);
let loadingPromise = null;

async function loadCityStateOptions() {
  if (cityStateOptions.value.length > 0) {
    return cityStateOptions.value;
  }
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = (async () => {
    const url = new URL(
      '@/assets/datasets/social_listening_city_state_options.json',
      import.meta.url,
    ).href;
    const response = await fetch(url);
    cityStateOptions.value = await response.json();
    loadingPromise = null;
    return cityStateOptions.value;
  })();
  return loadingPromise;
}

export function stripLocationObject(location) {
  if (!location || typeof location !== 'object') {
    return location;
  }
  const { city, administrativeDivision, country } = location;
  return {
    city: city ?? null,
    administrativeDivision: administrativeDivision ?? null,
    country: country ?? null,
  };
}

export function useLocationOptions() {
  function lookupLocationsInOptions(locations) {
    if (!locations?.length || !cityStateOptions.value?.length) {
      return locations;
    }
    return locations.map((location) => {
      const { city, administrativeDivision, country } = location;
      const matchingOption = cityStateOptions.value.find((option) => {
        const value = option.value || option;
        return (
          value.city === city &&
          value.administrativeDivision === administrativeDivision &&
          value.country === country
        );
      });
      if (matchingOption) {
        return matchingOption.value || matchingOption;
      }
      return location;
    });
  }

  return {
    cityStateOptions,
    lookupLocationsInOptions,
    loadCityStateOptions,
    stripLocationObject,
  };
}
